<template>
  {{ $t('common.account.info')}}
</template>
<script setup></script>
<style lang="less" scoped></style>